import ASkAiIcon from "@/shared/icons/ask-ai";

export default function StaticHeader() {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-2">
      <ASkAiIcon/>
      <h1 className="text-xl font-medium text-default-700">How can I help you today?</h1>
    </div>
  )
};